export { DeprecatedSubtleSwitch, SubtleSwitch } from './SubtleSwitch';
